import * as ActionCable from "~/vendor/actioncable";
import { Current } from "~/utils/Current";

// Build the WebSocket URL with organization context for direct shard routing.
function getCableUrl(): string {
  const baseUrl = ActionCable.getConfig("url") || ActionCable.INTERNAL.default_mount_path;
  const orgUuid = Current.organization?.uuid;

  if (orgUuid) {
    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set("organization_uuid", orgUuid);
    return url.pathname + url.search;
  }

  return baseUrl;
}

const cable = ActionCable.createConsumer(getCableUrl);

if (process.env.NODE_ENV === "development") {
  ActionCable.logger.enabled = true;
}

// Set data-cable-connected attribute when cable connects/disconnects
const originalRecordConnect = cable.connection.monitor.recordConnect;
const originalRecordDisconnect = cable.connection.monitor.recordDisconnect;

cable.connection.monitor.recordConnect = function () {
  document.body.setAttribute("data-cable-connected", "true");
  return originalRecordConnect.call(this);
};

cable.connection.monitor.recordDisconnect = function () {
  document.body.removeAttribute("data-cable-connected");
  return originalRecordDisconnect.call(this);
};

// TODO: add a react context which can propagate the consumer instead of using
// this global module, once we know every usage of the consumer is within a
// react tree capable of using a context. Ideally switch to use-action-cable
// hooks eventually.

export default cable;
